import React from "react";

export default function Competitors({ register, errors }) {
  const fieldName = "competitors";

  return (
    <div>
      <label className="wdc-field-label" htmlFor={fieldName}>
        Who are your main competitors?
      </label>
      <textarea
        id={fieldName}
        className="wdc-field"
        rows="4"
        placeholder="List competitor names or websites, and what you like or dislike about them"
        {...register(fieldName, { required: true })}
      />
      {errors[fieldName] && (
        <span className="wdc-error">This field is required</span>
      )}
    </div>
  );
}
